import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCarousel from 'vue-carousel';

import smoothscroll from 'smoothscroll-polyfill';


import Vue2Filters from 'vue2-filters';
import DurationFilter from './filters/duration.js';

import RootMobile from './components/RootMobile.vue';

import App from './App.js';
import EventBus from './EventBus.js';
import routes from './routes.js';
import SessionHelper from './SessionHelper.js';
import { api } from './API.js';

import PristineSeekbarFix from './standalone/seekbar-fix.js';
window.addEventListener('DOMContentLoaded', (e) => {
    console.log('fixing');
    for (let el of document.querySelectorAll('[data-seekbar-fix]')) {
        console.log('fixing', el);
        if (!el.dataset.seekbarFix) {
            PristineSeekbarFix(el);
        }
    }
});

smoothscroll.polyfill();


function unsupportedCheck() {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName  = navigator.appName;
    var fullVersion  = ''+parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion,10);
    var nameOffset,verOffset,ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
     browserName = "Opera";
     fullVersion = nAgt.substring(verOffset+6);
     if ((verOffset=nAgt.indexOf("Version"))!=-1)
       fullVersion = nAgt.substring(verOffset+8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
     browserName = "Microsoft Internet Explorer";
     fullVersion = nAgt.substring(verOffset+5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
     browserName = "Chrome";
     fullVersion = nAgt.substring(verOffset+7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
     browserName = "Safari";
     fullVersion = nAgt.substring(verOffset+7);
     if ((verOffset=nAgt.indexOf("Version"))!=-1)
       fullVersion = nAgt.substring(verOffset+8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
     browserName = "Firefox";
     fullVersion = nAgt.substring(verOffset+8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
              (verOffset=nAgt.lastIndexOf('/')) )
    {
     browserName = nAgt.substring(nameOffset,verOffset);
     fullVersion = nAgt.substring(verOffset+1);
     if (browserName.toLowerCase()==browserName.toUpperCase()) {
      browserName = navigator.appName;
     }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
       fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
       fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
     fullVersion  = ''+parseFloat(navigator.appVersion);
     majorVersion = parseInt(navigator.appVersion,10);
    }

    if (browserName == 'Safari' && (majorVersion == 7 || majorVersion == 8)) {
        return true;
    }
    return false;
}


// Mobile redirect
if (window.innerWidth >= 800) {
    window.location = '/app';
}

if (!unsupportedCheck()) {
    Vue.use(VueRouter);
    Vue.use(Vue2Filters);
    Vue.use(VueCarousel);

    Vue.filter('duration', DurationFilter);




    const router = new VueRouter({
        routes,
        base: '/mobile/',
        mode: 'history',
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition;
            }
            return { x: 0, y: 0 };
        }
    });


    router.beforeEach((to, from, next) => {
        if (to.meta.title) {
            document.title = to.meta.title
        }
        next();
    });



    RootMobile.router = router;
    const root = new Vue(RootMobile).$mount('[data-app=pristine-player]');
    const app = new App(root);



    EventBus.on('auth.success', (e) => {
        if (e.data.api_key) {
            SessionHelper.setAPIKey(e.data.api_key);
        }
    });


    EventBus.on('auth.triggerLogout', (e) => {
        SessionHelper.forgetAPIKey();
        var redirect = 'https://www.pristineclassical.com/pages/pristine-player-redirect?action=logout'
        redirect += '&redirect=https%3A%2F%2Fwww.pristineclassical.com%2Fpages%2Fplayer-auth%3Fmode%3Dmobile';
        window.location.href = redirect;
    });


    var apiKey = SessionHelper.getAPIKey();
    if (apiKey) {
        api.authenticate(apiKey, null, 'api_key', function afterAuth(ok) {
            console.log('auth mode', 'api_key');
            console.log('auth ok', ok);
        });
    } else {
        api.authenticate(null, null, 'anon', function afterAuth(ok) {
            console.log('auth mode', 'anon');
            console.log('auth ok', ok);
        });
    }

    app.init();

}



// WEBPACK FOOTER //
// ./src/main_mobile.js